import { Dispatch } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { SearchParams } from '@synergy/models';
import { createSearchByObject, mergeSearchParams } from '@synergy/utils';

import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';
import { Customer } from '../models/customer';

export const REQUEST_CUSTOMERS = 'REQUEST_CUSTOMERS';
export const RECEIVE_CUSTOMERS = 'RECEIVE_CUSTOMERS';
export const UPDATE_CUSTOMERS_SEARCH_PARAMS = 'UPDATE_CUSTOMERS_SEARCH_PARAMS';
export const RESET_CUSTOMERS_SEARCH = 'RESET_CUSTOMERS_SEARCH';

const requestCustomers = () => {
    return {
        type: REQUEST_CUSTOMERS,
    };
};

const receiveCustomers = (customers: PaginatedResponse<Customer>) => {
    return {
        type: RECEIVE_CUSTOMERS,
        customers,
    };
};

const updateCustomersSearchParams = (customersSearchParams: SearchParams) => {
    return {
        type: UPDATE_CUSTOMERS_SEARCH_PARAMS,
        customersSearchParams,
    };
};

export const resetCustomersSearch = () => {
    return {
        type: RESET_CUSTOMERS_SEARCH,
    };
};

export const updateCustomers = (customersSearchParams: Partial<SearchParams>) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const params = mergeSearchParams(getState().customers.searchParams, customersSearchParams);

        dispatch(updateCustomersSearchParams(params));
        dispatch(requestCustomers());

        const state = getState();
        const response = await api.customers.fetchRelatedCustomers(createSearchByObject(state.customers.searchParams));

        if (response.success) {
            dispatch(receiveCustomers(response.result));
        }
    };
};
